'use client'

import { useTranslations } from 'next-intl'
import { lodges } from '@/lib/data'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import FlipCard from '@/components/FlipCard'
import { useActivityVisibility } from '@/hooks/useActivityVisibility'
import styles from './lodges.module.css'
import { BreadcrumbSchema } from '@/lib/schema'


export default function LodgesPage() {
  const t = useTranslations('lodgesPage')
  const tCommon = useTranslations('common')
  const { isVisible } = useActivityVisibility()

  return (
    <>
      <BreadcrumbSchema items={[
        { name: tCommon('home'), href: '/' },
        { name: tCommon('lodges'), href: '/lodges/' },
      ]} />
      <Header />

      {/* 3D Cards Hero */}
      <section className={styles.flipHero}>
        <div className={styles.flipHeroBackground}></div>
        <div className={styles.flipHeroContent}>
          <span className={styles.flipOverline}>{t('hero.overline')}</span>
          <h1 className={styles.flipHeroTitle}>{t('hero.title')}</h1>
          <p className={styles.flipHeroSubtitle}>
            {t('hero.subtitle')}
          </p>
        </div>
      </section>

      {/* 3D Flip Cards Grid */}
      <section className={styles.flipSection}>
        <div className={styles.flipContainerWrapper}>
          <div className={styles.flipGrid}>
            {lodges.filter(lodge => isVisible(lodge.id, lodge.comingSoon)).map((lodge, index) => (
              <FlipCard key={lodge.id} lodge={lodge} index={index} />
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  )
}
